import React from "react";
import { FaWhatsapp, FaInstagram, FaLinkedinIn } from "react-icons/fa";

const LeftSocialIcons = () => {
  return (
    <div className="left-social-icons">
      <a 
        href="https://wa.me/919049442717?text=Can%20I%20get%20more%20information%20for%20this%3F" 
        target="_blank" 
        rel="noopener noreferrer"
      >
        <FaWhatsapp />
      </a>

      <a 
        href="https://www.instagram.com/nmdinfotech/?igsh=M2lnM205YXZ6b3lp#" 
        target="_blank" 
        rel="noopener noreferrer"
      >
        <FaInstagram />
      </a>

      <a 
        href="https://www.linkedin.com/company/nmd-pvt-ltd/posts/?feedView=all" 
        target="_blank" 
        rel="noopener noreferrer"
      >
        <FaLinkedinIn />
      </a>
    </div>
  );
};

export default LeftSocialIcons;
